import {get} from "../utils";
import {getActiveChannel, getStoredChannel} from "../authentication/utils";

export default host => (id, playlistId = undefined, isPublic = false) =>
  get(`${host}/${(!!getStoredChannel() && !isPublic) ? `${getStoredChannel().visibility ==="public" ? "public/": ""}channels/${getActiveChannel()}/` : ""}${playlistId ? `${isPublic ? "public/" : ""}playlists/${playlistId}/`: ``}contentCreations/${id}/download`)
    .then(response => response.json())
